interface FlowScreen {
  webviewUri: string;
}

export enum CheckoutButtonType {
  CREDIT_CARD = "stripe",
  GOOGLE_PAY = "google_play",
  AMAZON_PAY = "amazon",
  SAMSUNG_PAY = "samsungPay",
  APPLE_PAY = "apple",
  REDEEM_CODE = "redeemCode",
}

export interface PlanLogo {
  url: string;
}
export interface CheckoutPlan {
  uuid: string;
  sku: string;
  formattedPrice: string;
  billingPeriod: "monthly";
  publicId: string;
  title?: string;
  description?: string;
  logo?: PlanLogo;
}
export interface CheckoutButton {
  type: CheckoutButtonType;
  plan: CheckoutPlan;
}
export enum CarrierType {
  A1 = "a1",
  CELCOM = "celcom",
  FORTUMO = "fortumo",
  SWISSCOM = "swisscom",
  MTI = "moratelindo",
  SMART_AXIATA = "smart_axiata",
  ORANGE_JORDAN = "orange_jordan",
  STC = "stc",
}
export interface Carrier {
  type: CarrierType;
  plan: CheckoutPlan;
}
export interface CheckoutScreen extends FlowScreen {
  buttons: CheckoutButton[];
  carriers?: Carrier[];
}
export interface OnboardingFlowV3 {
  welcomeScreen: FlowScreen;
  signupScreen?: FlowScreen;
  signinScreen?: FlowScreen;
  passwordResetScreen?: FlowScreen;
  checkoutScreen?: CheckoutScreen;
  checkoutCardScreen?: FlowScreen;
  checkoutRedeemScreen: FlowScreen;
  carrierScreen?: FlowScreen;
  carriersScreen?: FlowScreen;
  easyRegisterScreen?: FlowScreen;
}

export interface OnboardingFlowV4 {
  buttons: CheckoutButton[];
  carriers?: Carrier[];
}
